import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import "bootstrap-select";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsconfig from "./aws-exports";
import { Functions } from "./functions/Functions";
import VueMasonry from 'vue-masonry-css'

Amplify.configure(awsconfig);

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(VueMasonry);
Vue.use(Vuex);
Vue.use(Functions);

Vue.config.productionTip = false;
const { createApolloFetch } = require("apollo-fetch");
const apolloFetch = createApolloFetch({
  uri: process.env.VUE_APP_URI
});

const awsCreds = {
  AccountId: "422746731938",
  RoleArn:
    "arn:aws:iam::422746731938:role/fundsgranted-web-20191115122513-unauthRole",
  IdentityPoolId: "us-east-1:20325c86-ea71-4ba0-921b-27bf67c4eb50"
};

const store = new Vuex.Store({
  state: {
    user: null,
    loading: false,
    fetcher: apolloFetch,
    awsCreds: awsCreds,
    unsplashAccessKey: process.env.UNSPLASH_ACCESS_KEY
  },
  getters: {
    awsCreds: state => {
      return state.awsCreds;
    },

    fetcher: state => {
      return state.fetcher;
    },
    user: state => {
      return state.user;
    },
    loading: state => {
      return state.loading;
    },
    unsplashAccessKey: state => {
      return state.unsplashAccessKey;
    }
  },
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateLoading(state, loading) {
      state.loading = loading;
    },
    resetUser(state) {
      state.user = null;
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
